import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import axios from "axios";
import MarkdownRenderer from "react-markdown-renderer";

const API_URL = process.env.REACT_APP_API_URL;

const PromoDetail = props => {
  const id = props.match.params.id;
  const [isLoading, setIsLoading] = useState(false);
  const [promo, setPromo] = useState([]);
  useEffect(() => {
    setIsLoading(true);
    const reqpromodetail = axios.get(`${API_URL}/promos/${id}`);
    axios
      .all([reqpromodetail])
      .then(
        axios.spread((...res) => {
          console.log(res);
          const promo = res[0].data;
          setPromo(promo);
          setIsLoading(false);
        })
      )
      .catch(err => {
        console.log(err);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return null;
    // return <Loading show={isLoading} type="full" />;
  }
  return (
    <div className="artikeldetail-page">
      <Navbar />
      <div className="artikeldetail-content">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg">
              <div className="d-none d-lg-block">
                <ol class="breadcrumb bg-transparent mb-0">
                  <li class="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li class="breadcrumb-item">
                    <Link to="/promo">Promo</Link>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    {id}
                  </li>
                </ol>
              </div>
            </div>
            <div className="col-lg-auto">
              <div className="date">Promo Berakhir {promo.expiredate}</div>
            </div>
          </div>
          <div className="text-heading text-center mt-3">{promo.title}</div>
          <div className="row justify-content-center mt-5 mb-5">
            <div className="col-lg-5">
              <img
                src={promo.image ? API_URL + promo.image.url : ""}
                alt="..."
                className="img-news w-100"
              />
            </div>
          </div>
          <div className="desc">
            <MarkdownRenderer markdown={promo.content} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PromoDetail;
